import React, {Component} from 'react';
import {withApplicationContext} from "../../../contexts/ApplicationContext"
import {
    SectionContainer,
    SectionTitle,
    SectionBody, CenterCol,
    PrimaryButton, CenterText,
    ColImage
} from "./style.jsx";
import {Container, Row, Col} from 'react-bootstrap';

class PracticeTable extends Component {
    render() {
        const {applicationContext} = this.props;
        return (
            <SectionContainer id={"section-practice"}>
                <Container>
                    <SectionTitle><div className={"wrapper"}>{applicationContext.translator("Practice Table")}</div></SectionTitle>
                    <SectionBody>
                        <Row>
                            <Col md={6}>
                                <ColImage><img src={"/assets/img/practice-table.jpg"} alt={applicationContext.translator("Practice Table")} loading="lazy"/></ColImage>
                            </Col>
                            <CenterCol md={6}>
                                <CenterText>
                                <div dangerouslySetInnerHTML={{ __html: applicationContext.translator("Practice table text") }}></div>
                                    <PrimaryButton to={"/practice?lang="+applicationContext.state.lang}>{applicationContext.translator("Play On Practice Table")}</PrimaryButton>
                                </CenterText>

                            </CenterCol>

                        </Row>
                    </SectionBody>

                </Container>
            </SectionContainer>

        );
    }
}

export default withApplicationContext(PracticeTable);